import React from 'react';
import OrderHistory from './OrderHistory';
import OrderSummary from 'ViewModels/Components/MyAccount/OrderHistory/OrderSummary';
import OrderHistoryStore from './OrderHistoryStore';
import OrderHistoryActions from './OrderHistoryActions';
import { getUrlParameter } from 'tools';


export default class OrderHistoryContainer extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = OrderHistoryStore.getState();
		this.onChange = this.onChange.bind(this);
	}
	
	componentDidMount() {
		OrderHistoryStore.listen(this.onChange);
		OrderHistoryActions.getOrderList();
		let tab = getUrlParameter('tab');
		let OrderID = window.location.hash ? window.location.hash.replace('#', '') : null;
		if(OrderID) {
			window.location.replace(`${window.jenkon.consultantRoot}MyAccount#`);
			OrderHistoryActions.getOrderDetail(OrderID);
		}
	}

	componentWillUnmount() {
		OrderHistoryStore.unlisten(this.onChange);
	}

	onChange(state) {
		console.log(state);
		this.setState(state);
	}
	
	render(){
		return this.state.currentComponent !== 'history' ? <OrderSummary {...this.props} Details={this.state.Details}  backToList={OrderHistoryActions.switchComponent.bind(this, 'history')} /> : <OrderHistory {...this.props} OrderList={this.state.OrderList} getOrderDetails={OrderHistoryActions.getOrderDetail} />;
	}
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/OrderHistory/OrderHistoryContainer.js